import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './modules/app/app.container';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import DataStackerAppThemeProvider from './modules/app/app.theme';
import store from './modules/common/redux.store';

ReactDOM.render(
  <Provider store={store}>
    <DataStackerAppThemeProvider>
      <App />
    </DataStackerAppThemeProvider>
  </Provider>
  , document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
